import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import {
	Table,
	TableBody,
	TableHeader,
	TableHeaderColumn,
	TableRow,
	TableRowColumn
} from "material-ui/Table";
import {
	PAYMENT_METHODS_NEW,
	PAYMENT_METHODS_EDIT,
	INDEX
} from "../../config/RoutesConstants";
import {
	MODE_CRU_CREATE,
	MODE_CRU_UPDATE,
	MODE_CRU_SHOW
} from "../../actions/ActionConstants";
import { Card, CardTitle, CardText } from "material-ui/Card";
import OptionsTableRowColumn from "../../components/OptionsTableRowColumn/OptionsTableRowColumn";
import FilterCard from "../../components/FilterCard/FilterCard";
import Paginator from "../../components/Paginator/Paginator";
import { ROL_ADMIN, ROL_SUB_ADMIN } from "../../common/Constants";
import {
	actionChangePaymentMethodProps,
	actionGetPaymentMethodList
} from "../../actions/PaymentMethodActions";

let limitePagina = 10;

class PaymentMethodIndex extends Component {
	constructor(props) {
		super(props);
		this.handleShow = this.handleShow.bind(this);
		this.onCreateOrUpdate = this.onCreateOrUpdate.bind(this);
		this.getPaymentMethods = this.getPaymentMethods.bind(this);
		this.onChangePage = this.onChangePage.bind(this);
		this.renderBodyRows = this.renderBodyRows.bind(this);
		this.renderPaginator = this.renderPaginator.bind(this);
	}

	componentWillMount() {
		if (this.props.rol !== ROL_ADMIN && this.props.rol !== ROL_SUB_ADMIN)
			this.props.history.push(INDEX);
		else this.getPaymentMethods(1, limitePagina);
	}

	getPaymentMethods(page, limit) {
		this.props.actionGetPaymentMethodList(null, page, limit);
	}

	renderPaginator() {
		return (
			<Paginator
				page={this.props.page}
				pageLimit={limitePagina}
				total={this.props.total}
				onChangePage={this.onChangePage}
			/>
		);
	}

	onCreateOrUpdate(paymentMethod) {
		if (paymentMethod) {
			this.props.actionChangePaymentMethodProps({
				paymentMethod,
				modeCRU: MODE_CRU_UPDATE
			});
			this.props.history.push(PAYMENT_METHODS_EDIT);
		} else {
			this.props.actionChangePaymentMethodProps({
				paymentMethod: null,
				modeCRU: MODE_CRU_CREATE
			});
			this.props.history.push(PAYMENT_METHODS_NEW);
		}
	}

	handleShow(paymentMethod) {
		this.props.actionChangePaymentMethodProps({
			modeCRU: MODE_CRU_SHOW,
			paymentMethod
		});
		this.props.history.push(PAYMENT_METHODS_EDIT);
	}

	renderBlank() {
		return (
			<TableRow key={1}>
				<TableRowColumn>
					<p>No se encontraron resultados</p>
				</TableRowColumn>
			</TableRow>
		);
	}

	onChangePage(page) {
		this.props.actionChangePaymentMethodProps({ page });
		this.getPaymentMethods(page, limitePagina);
	}

	renderBodyRows(paymentMethodsList) {
		let Edit = this.onCreateOrUpdate;
		const Show = this.handleShow;
		return _.map(paymentMethodsList, (item, i) => {
			let paymentMethod = item;
			return (
				<TableRow key={i} style={{ height: "16px", fontSize: "12px" }}>
					<TableRowColumn style={{ marginLeft: 20 }}>
						{paymentMethod.name}
					</TableRowColumn>
					<TableRowColumn style={{ marginLeft: 20 }}>
						{paymentMethod.agreement}
					</TableRowColumn>
					<TableRowColumn style={{ width: "20%" }}>
						<OptionsTableRowColumn
							handleEdit={() => Edit(item)}
							handleShow={() => Show(item)}
							showTooltip="Ver"
						/>
					</TableRowColumn>
				</TableRow>
			);
		});
	}

	render() {
		return (
			<div className="center">
				<Card className="card">
					<CardTitle
						title="Forma de Pago"
						subtitle="Agregue o Modifique Formas de Pago"
					/>
					<CardText>
						<FilterCard onTouchTapNew={() => this.onCreateOrUpdate()} />
						<Table selectable={false}>
							<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
								<TableRow>
									<TableHeaderColumn>Nombre</TableHeaderColumn>
									<TableHeaderColumn>Número de convenio</TableHeaderColumn>
									<TableHeaderColumn style={{ width: "20%" }}>
										Acciones
									</TableHeaderColumn>
								</TableRow>
							</TableHeader>
							<TableBody stripedRows displayRowCheckbox={false}>
								{!_.isEmpty(this.props.paymentMethodsList)
									? this.renderBodyRows(this.props.paymentMethodsList)
									: this.renderBlank()}
							</TableBody>
						</Table>
					</CardText>
					{!_.isEmpty(this.props.paymentMethodsList)
						? this.renderPaginator()
						: ""}
				</Card>
			</div>
		);
	}
}

function mapStateToProps(store) {
	return {
		paymentMethodsList: store.paymentMethod.paymentMethodsList,
		modeCRU: store.paymentMethod.modeCRU,
		page: store.paymentMethod.page,
		total: store.paymentMethod.total,
		rol: store.app.rol
	};
}

export default connect(mapStateToProps, {
	actionChangePaymentMethodProps,
	actionGetPaymentMethodList
})(PaymentMethodIndex);



// WEBPACK FOOTER //
// ./src/screens/PaymentMethod/PaymentMethodIndex.js